export default __webpack_public_path__ + "static/media/arrowDown.6e1cede8.svg";